module.exports = __webpack_public_path__ + "img/16581269_L.f3b65f58.png";